import { PromoType } from '../constants';
import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-promo';
const CLS_LABEL = 'promo';

const CLS_CHATHOST = `${CLS}-${PromoType.Chathost}`;
const CLS_PROMO = `${CLS}-${PromoType.Promotion}`;

export function maybeValidatePromo(promoselector: HTMLSelectElement, promoInput: HTMLInputElement): boolean {
    if (promoselector && promoInput) {
        return validatePromo(promoselector, promoInput);
    }
    return true;
}

export function validatePromo(promoselector: HTMLSelectElement, promoInput: HTMLInputElement): boolean {
    const promoType = parseInt(promoselector.value, 10);

    if (promoType > PromoType.Other && promoInput.value === '') {
        const cls = `${CLS}-${promoType}`;
        addVisible(promoInput, cls);
        return false;
    }
    removeVisible(promoInput, CLS_CHATHOST, CLS_PROMO);
    return true;
}

export function liveValidatePromo(promoselector: HTMLSelectElement, promoInput: HTMLInputElement) {
    promoInput.addEventListener('input', function (e: InputEvent) {
        validatePromo(promoselector, promoInput);
    });
    promoInput.addEventListener('change', function (e: InputEvent) {
        validatePromo(promoselector, promoInput);
    });
    promoInput.addEventListener('blur', function (e: InputEvent) {
        validatePromo(promoselector, promoInput);
    });

    promoselector.addEventListener('change', function (e: InputEvent) {
        removeVisible(promoInput, `${CLS_LABEL}--${PromoType.Chathost}`, `${CLS_LABEL}--${PromoType.Promotion}`, `${CLS_LABEL}--${PromoType.Other}`);
        removeVisible(promoInput, CLS_CHATHOST, CLS_PROMO);

        const promoType = parseInt(promoselector.value, 10);
        addVisible(promoInput, `${CLS_LABEL}--${promoType}`);
    });
}
